import { BlockService } from "./../block.service";
import { Component, OnInit } from "@angular/core";
import { LoginService } from "../login.service";
import { CalendarOptions } from "@fullcalendar/core"; // useful for typechecking
import { ViewChild } from "@angular/core";
import { DateSelectArg, EventApi } from "@fullcalendar/core";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction"; // Import Interaction plugin
import { AppointmentsService } from "../appointments.service";
import moment from "moment";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { SettingsService } from "../settings.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
    selector: "app-appointments-general",
    templateUrl: "./appointments-general.component.html",
    styleUrls: ["./appointments-general.component.scss"],
    standalone: false
})
export class AppointmentsGeneralComponent implements OnInit {
  @ViewChild("fullcalendar") fullcalendarComponent;

  events=[]
  calenderFormattedEvents = [];
  blocks=[]
  calenderFormattedBlocks = [];
  showCalendar = false;
  showErrorModal = false;
  showSelection = false;
  showBlock = false;
  selectedDateInfo;
  selectedEventInfo;
  page = "Calendar";
  examsLegend = {};
  holidays = [];
  holidayFetchStatus: { [year: number]: 'fetching' | 'fetched' | 'error' } = {};
  slotMinTime = "06:00:00";
  slotMaxTime = "23:00:00";
  ignoreFirstDatesSetTrigger = false;
  startDateDisplay
  endDateDisplay
  startDateDisplayWithGap
  endDateDisplayWithGap
  businessHours=false
  eventHover = false;
  tooltipText = '';
  tooltipPosition = { x: '0px', y: '0px' };
  showAlert=false
  viewType

  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: "",
      center: "title",
      right: "prev timeGridDay timeGridWeek dayGridMonth next",
    },
    initialView: "timeGridWeek",
    nowIndicator: true,
    weekends: true,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    allDaySlot: false,
    slotMinTime: "06:00:00",
    slotMaxTime: "24:00:00",
    slotDuration: "01:00:00",
    eventMouseEnter: this.handleEventMouseEnter.bind(this),
    eventMouseLeave: this.handleEventMouseLeave.bind(this),
    datesSet: this.handleDatesSet.bind(this),
    businessHours:this.businessHours,
    select: this.handleDateSelect.bind(this),
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
    events: this.calenderFormattedEvents,
    locale: "en-gb",
    navLinks: true,
    eventDrop: this.handleEventDrop.bind(this),
    views: {
      dayGridMonth: {
        titleFormat: { year: "numeric", month: "long" },
      },
      timeGridWeek: {
        titleFormat: "",
        dayHeaderFormat: {
          weekday: "long",
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        },
      },
      timeGridDay: {
        dayHeaderFormat: {
          weekday: "long",
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        },
      },
    },
    slotLabelFormat: {
      hour: "2-digit",
      minute: "2-digit",
    },
  };
  currentEvents: EventApi[] = [];
  calendarVisible = true;
  showAppointment = false;
  showSelectPatient = false;
  showPatDetails = false;
  showPat = false;
  settingSub: Subscription;
  showPrintIcon: boolean = false;
 
  constructor(
    public ls: LoginService,
    public appointmentService: AppointmentsService,
    public patientsService: PatientsService,
    public settings: SettingsService,
    private router: Router,
    public BlockService: BlockService
  ) {
    this.ls.loginMissing();
  }

   ngOnInit() {
    // this.settings.getExams();
    this.showCalendar = true;
    this.settingSub = this.settings.examsSettingsLoaded$.subscribe((exams) => {
      this.getExamsLegend(exams);
    });
    this.getHolidays(new Date().getFullYear());
    this.refetchActivityHours()
  }

getHolidays(year: number): void {
  if (this.holidayFetchStatus[year]) {
    return;
  }

  this.holidayFetchStatus[year] = 'fetching';
  this.settings.getHolidays(year).subscribe({
    next: (holidays) => {
      const newHolidays = holidays.map((holiday) => ({
        title: holiday.hebrew,
        start: holiday.date,
        allDay: true,
        display: "background",
      }));

      this.holidays = [...new Set([...this.holidays, ...newHolidays])];

      this.holidayFetchStatus[year] = 'fetched';
      this.initEvents(); 
    },
    error: (error) => {
      console.error('Error fetching holidays:', error);
      this.holidayFetchStatus[year] = 'error';
    }
  });
}


  handleEventMouseEnter(event) {
    if(!event.event.extendedProps.AutoIndex ||event.event.extendedProps.type=='block' ) return 
    const startDate = new Date(event.event.extendedProps.aptTime);
    const endDate = new Date(startDate.getTime() + event.event.extendedProps.aptlength * 60000); // assuming aptlength is in minutes

    const startTime = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    const endTime = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    const examType = event.event.extendedProps.examName || '';
    const fullName = `${event.event.extendedProps.Last} ${event.event.extendedProps.First}`;
    const mobile = event.event.extendedProps.Mobile;
    const appointmentConfirm=event.event.extendedProps.arrivalConfirm
   this.tooltipText = ` ${startTime}-${endTime}<br> ${examType}<br> ${fullName}<br> ${mobile}`;
  //  if(appointmentConfirm){
  //   this.tooltipText+=`<img src="../../assets/icons/checkedGreen.svg"/>`
  //  }

    this.tooltipPosition = {
      x: `${event.jsEvent.clientX + window.scrollX + 10}px`,
      y: `${event.jsEvent.clientY + window.scrollY + 10}px`
    };
    this.eventHover = true;
  }

  handleEventMouseLeave(event) {
     this.eventHover = false;
  
  }

  async refetchEvents(startDate,endDate) {
    const result = await this.appointmentService.fetchEvents(
      startDate,
      endDate
    );
    this.events = result["events"];
    this.blocks = result["blocks"];
    this.initEvents()
  }

  initEvents(){

    this.calenderFormattedEvents = this.formatEvents(this.events);
    this.calenderFormattedBlocks = this.formatBlocks(this.blocks);
    const combinedItems = [
      ...this.calenderFormattedEvents,
      ...this.calenderFormattedBlocks,
      ...this.holidays,
    ];

    this.calendarOptions = { ...this.calendarOptions, events: combinedItems };
  }
  
  handleViewChange(viewType: string=this.viewType) {
    this.showPrintIcon = (viewType === 'dayGridDay' || viewType === 'timeGridDay' || viewType === 'listDay') && this.ls.doctor;
    this.showErrorModal=false
  }

  refetchActivityHours(){
    if(!this.ls.doctor){
      this.businessHours=false
      this.calendarOptions = { ...this.calendarOptions, businessHours: this.businessHours };
       return
    }
    this.settings.getActivityHours(true).subscribe({
      next: (data) => {
        this.businessHours=data
        this.calendarOptions = { ...this.calendarOptions, businessHours: this.businessHours };
      },
      error: (error) => {
        console.error('Error refetchActivityHours:', error);
        this.businessHours=false
        this.calendarOptions = { ...this.calendarOptions, businessHours: this.businessHours };
      }
    })
  }

  formatEvents(events: any[]) {
    return events.map((event) => {
      const isEventConfirmed = event.arrivalConfirm
      return {
        ...event,
          title: `${isEventConfirmed? '✅':""}${event.First} ${event.Last} `,
        start: new Date(event.aptTime),
        end: this.calculateEndTime(new Date(event.aptTime), event.aptlength),
        color: this.getEventTypeColor(event.examTypeID)
      };
    });
  }

  formatBlocks(blocks) {
    return blocks.map((block) => ({
      ...block,
      type: "block",
      aptTime: block.startTime,
      blockEndTime:block.endTime,
      aptlength: block.duration,
      start: new Date(block.startTime),
      end: this.calculateEndTime(new Date(block.startTime), block.duration),
      color: "#a4cd9d",
      title: block.comment? block.comment :"",
    }));
  }

  calculateEndTime(startTime: Date, duration: number): Date {
    const startMoment = moment(startTime);
    const endMoment = startMoment.add(duration, "minutes");
    return endMoment.toDate();
  }

  ngOnDestroy(): void {
    if (this.settingSub) {
      this.settingSub.unsubscribe();
    }
  }

  getEventTypeColor(typeID: string) {
    const typeColorMapper = this.settings.examsSettings;
    const exam = typeColorMapper.find((exam) => exam.AutoIndex == typeID);
    return exam ? exam.Color : null; /**default value is blue of calendar */
  }

  handleCalendarToggle() {
    this.calendarVisible = !this.calendarVisible;
  }

  handleWeekendsToggle() {
    const { calendarOptions } = this;
    calendarOptions.weekends = !calendarOptions.weekends;
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    if (!this.ls.doctor) {
      this.showErrorModal = true;
      return;
    }
    this.selectedDateInfo = selectInfo;
    this.showSelection = true;
    this.selectedEventInfo = null;
    return;
  }

  handelAddAppointment(selectInfo = this.selectedDateInfo) {
    this.showAlert=false
    const inBusinessHours=this.checkBusinessHours(selectInfo.start,selectInfo.end,this.businessHours)
    if (!inBusinessHours) {
      this.showAlert=true
      return
    }
    this.addAppointment()
    
  }
  addAppointment(selectInfo = this.selectedDateInfo){
    this.showSelection = false;
    this.appointmentService.startDate = selectInfo.start;
    this.appointmentService.endDate = selectInfo.end;
    this.appointmentService.duration =null
      // this.appointmentService.calculateDuration(
      //   selectInfo.start,
      //   selectInfo.end
      // );
    this.appointmentService.AutoIndex = null;

    if (this.patientsService.currentPatient) {
      this.showAppointment = true;
    } else {
      this.showSelectPatient = true;
    }

    const calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection
  }

  checkBusinessHours(startDate, endDate, businessHours) {
    if(!businessHours || !businessHours.length) return true
    const start = startDate.toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' });
    const end = endDate.toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' });

    const startDay = new Date(start).getDay();
    const endDay = new Date(end).getDay();
    const startTime = new Date(start).toTimeString().substr(0, 5);
    const endTime = new Date(end).toTimeString().substr(0, 5);

    const startDayHours = businessHours.filter(d => d.daysOfWeek.includes(startDay));
    const endDayHours = businessHours.filter(d => d.daysOfWeek.includes(endDay));

    const isValidStart = startDayHours.some(d => startTime >= d.startTime && startTime < d.endTime);
    const isValidEnd = endDayHours.some(d => endTime > d.startTime && endTime <= d.endTime);

    return isValidStart && isValidEnd;
}


  handleEventClick(clickInfo) {
    this.selectedEventInfo = clickInfo.event.extendedProps;

    if (this.selectedEventInfo.type === "block") {
      this.BlockService.setBlock(this.selectedEventInfo);
      this.showBlock = true;
    }
    // appointment
    else {
      this.appointmentService.setAppointment(this.selectedEventInfo);
      this.patientsService.setPat(
        new Patient(
          this.selectedEventInfo.ID,
          this.selectedEventInfo.First,
          this.selectedEventInfo.Last
        )
      );
      this.patientsService.currentPatient.PID = this.selectedEventInfo.PID;
      this.patientsService.currentPatient.Mobile=this.selectedEventInfo.Mobile
      this.showAppointment = true;
    }
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  handleCloseAppointmentModal(saveAppointment) {
    this.showAppointment = false;
    this.selectedEventInfo = null;
    this.refetchEvents(this.startDateDisplayWithGap,this.endDateDisplayWithGap);
    this.patientsService.resetPat();
  }

  handleClosePatientSearchModal(openOtherModalName) {
    this.showSelectPatient = false;
    if (openOtherModalName == "patDetails") {
      this.showPatDetails = true;
    }
    if (openOtherModalName == "appointmentDetails") {
    }
  }

  handleClosePatDetailsModal(openOtherModalName) {
    this.showPatDetails = false;

    if (!openOtherModalName) {
      this.patientsService.resetPat();
      return;
    }
    if (this.page == "Calendar") this.showAppointment = true;
    if (this.page == "Patients") this.showPat = true;
  }

  handleCloseBlockModal() {
    this.showBlock = false;
    this.selectedEventInfo = null;
    this.refetchEvents(this.startDateDisplayWithGap,this.endDateDisplayWithGap);
  }

  getDoctors() {
    return this.ls.clinicUsers;
  }

  handelBlock(selectInfo = this.selectedDateInfo) {
    this.showSelection = false;
    this.BlockService.startDate = selectInfo.start;
    this.BlockService.endDate = selectInfo.end;
    this.BlockService.duration = this.BlockService.calculateDuration(
      selectInfo.start,
      selectInfo.end
    );
    this.BlockService.AutoIndex = null;
    this.showBlock = true;
  }

  async handleEventDrop(info) {
    // Extract new start and end dates from the event after drop
    const { event } = info;
    const newStart = event.start;
    const newEnd = event.end;
    let result
    try {
      this.selectedEventInfo = { ...event.extendedProps };
      if(event.extendedProps.type=='block'){
      this.BlockService.setBlock(this.selectedEventInfo)
      const newDuration = this.BlockService.calculateDuration(
        newStart,
        newEnd
      );
      const updatedBlock=this.selectedEventInfo;
      updatedBlock["duration"] = newDuration;
        updatedBlock["startHour"] = this.appointmentService.appointmentHour(
          new Date(newStart)
        );
        updatedBlock["endHour"] = this.appointmentService.appointmentHour(
          new Date(newEnd)
        );
        updatedBlock["blockStartDate"] = new Date(newStart);
        updatedBlock["blockEndDate"] = new Date(newEnd);
        result = await this.BlockService.updateBlock(
          updatedBlock
        );

      }
      // appointment 
      else{
        this.appointmentService.setAppointment(this.selectedEventInfo);
        const newDuration = this.appointmentService.calculateDuration(
          newStart,
          newEnd
        );
        const updatedAppointment = this.selectedEventInfo;
        updatedAppointment["duration"] = newDuration;
        updatedAppointment["startHour"] = this.appointmentService.appointmentHour(
          new Date(newStart)
        );
        updatedAppointment["appointmentDate"] = new Date(newStart);
  
         result = await this.appointmentService.updateAppointment(
          updatedAppointment
        );

      }

      
      if (result["status"] == "ok") {
        this.refetchEvents(this.startDateDisplayWithGap,this.endDateDisplayWithGap);
      }
    } catch (error) {
      info.revert();
      console.error("Error during the update Appointment:", error);
    }
  }

  setPage(page: string, resetPatient) {
    this.page = page;
    this.showPat = false;
    if (page == "Patients") {
      this.showSelectPatient = true;
    }
    if (page == "Calendar") {
      this.showSelectPatient = false;
   
      // this.patientsService.currentPatient=null
    }
    if (resetPatient) {
      this.patientsService.currentPatient = null;
    }
  }

  goToDate(date: Date) {
    this.ignoreFirstDatesSetTrigger = true;
    date = new Date(date);
    const calendarApi = this.fullcalendarComponent.getApi();
    calendarApi.changeView("timeGridDay");
    calendarApi.gotoDate(date);
  }

  async getExamsLegend(exams) {
    let legend = {};
    for (let i = 0; i < exams.length; i++) {
      let exam = exams[i];
      legend[exam.examName] = exam["Color"]; // Assuming each exam has a 'name' property to use as a key
    }
    this.examsLegend = legend;
  }

  goToSettings() {
    this.router.navigate(["/settings"]);
  }
 


  handleDatesSet(params) {

    this.viewType = params.view.type;
    this.handleViewChange(this.viewType);

    if (this.ignoreFirstDatesSetTrigger) {
      this.ignoreFirstDatesSetTrigger = false;
      return; 
    }

    
    const startYear = params.start.getFullYear();
    const endYear = params.end.getFullYear();
  
    if (startYear === endYear) {
      this.getHolidays(startYear);
    } else {
      this.getHolidays(startYear);
      this.getHolidays(endYear);
    }
    
    // add 1 weeks gap to handel appointments or block that continue from the days before to this days
    const startDayWithGap= moment(params.start).subtract(1,'w').toISOString()
    const endDayWithGap= moment(params.end).add(1,'w').toISOString()
    this.startDateDisplay=params.start
    this.endDateDisplay=params.end
    this.startDateDisplayWithGap=startDayWithGap
    this.endDateDisplayWithGap=endDayWithGap
    this.refetchEvents(startDayWithGap, endDayWithGap)
  }

  print(){
    const startDate = new Date(this.startDateDisplay).toISOString();
    console.log(startDate);  
    let printUrl = `api/print/day/${startDate}/${this.ls.doctor}`;
    window.open(printUrl)
  }

  

  
  
}
